import React from 'react';
import { AppInsightsErrorBoundary, useAppInsightsContext } from '@microsoft/applicationinsights-react-js';
import { InternalServerError } from '@pages/errors/InternalServerError/InternalServerError';

type Props = {
  children: any; // need any here since AppInsightsErrorBoundary types children as React.ReactElement, which does not support multiple React Nodes
};

const ErrorBoundary = ({ children }: Props) => {
  const appInsight = useAppInsightsContext();
  return (
    <AppInsightsErrorBoundary appInsights={appInsight} onError={InternalServerError}>
      {children}
    </AppInsightsErrorBoundary>
  );
};

export default ErrorBoundary;
